// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GeneratePdfFromTemplateRequestContent {
    static getAttributeTypeMap() {
        return GeneratePdfFromTemplateRequestContent.attributeTypeMap;
    }
}
GeneratePdfFromTemplateRequestContent.discriminator = undefined;
GeneratePdfFromTemplateRequestContent.additionalProperties = false;
GeneratePdfFromTemplateRequestContent.attributeTypeMap = [
    {
        "name": "page",
        "baseName": "page",
        "type": "number"
    },
    {
        "name": "content",
        "baseName": "content",
        "type": "string"
    },
    {
        "name": "font",
        "baseName": "font",
        "type": "string"
    },
    {
        "name": "size",
        "baseName": "size",
        "type": "number"
    },
    {
        "name": "style",
        "baseName": "style",
        "type": "number"
    },
    {
        "name": "color",
        "baseName": "color",
        "type": "string"
    },
    {
        "name": "point",
        "baseName": "point",
        "type": "GeneratePdfFromTemplateRequestContentPoint"
    },
];
//# sourceMappingURL=generatePdfFromTemplateRequestContent.js.map